import React from 'react'
import { ChineseSurnamePicker } from '@fs/zion-homelands-shared'
import { MenuSearch } from '@fs/zion-icon'
import { i18n } from '@fs/zion-locale'
import { BillboardButton, Row, Separator } from '@fs/zion-ui'
import { useQueryParams, useLocation } from '@fs/zion-router'
import ZionForm, { useZionForm } from '@fs/zion-form'

import { removeEmptyCriteria } from 'helpers/searchQueryHelpers'
import { useRouterHelper } from '../../hooks'
import transl from './LandingPageJiapuSearchForm.transl'

export default function LandingPageJiapuSearchForm() {
  const { query } = useQueryParams()
  const { navigate } = useRouterHelper()
  const methods = useZionForm({
    mode: 'all',
    defaultValues: {
      ...query,
    },
  })
  const location = useLocation()
  const searchResultsPath = `${location.pathname.replace(/\/+$/, '')}/search-results`

  function handleSurnameSelected(selectedSurname) {
    methods.setValue('surname', selectedSurname ? selectedSurname.characters : null)
  }

  function submitSearchCriteria(values) {
    const searchCriteria = removeEmptyCriteria({
      volumeSetSearch: 'jiapu',
      ...values,
    })
    navigate({ path: searchResultsPath, query: searchCriteria })
  }

  return (
    <>
      {query && (
        <ZionForm methods={methods} onSubmit={submitSearchCriteria}>
          <ChineseSurnamePicker
            clearable
            label={i18n.t('formInputs.surname', 'Surname')}
            name="surname"
            onSuggestionSelected={handleSurnameSelected}
          />

          <Separator size="md" />

          <Row>
            <BillboardButton Icon={MenuSearch} name="submit" emphasis="lightHigh" type="submit">
              {transl.searchImageGroups()}
            </BillboardButton>
            <BillboardButton
              name="submitAdvanced"
              emphasis="low"
              onClick={() =>
                submitSearchCriteria({
                  advanced: 'true',
                  surname: methods.getValues().surname,
                })
              }
            >
              {transl.advancedSearch()}
            </BillboardButton>
          </Row>

          <Separator size="lg" />
        </ZionForm>
      )}
    </>
  )
}
